import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { WorkReadyStatus } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-filter-panel-status',
  templateUrl: './filter-panel-status.component.html',
  styleUrls: ['./filter-panel-status.component.scss'],
  host: { class: 'filter-panel-status' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelStatusComponent implements OnInit {
  @Input() statuses: Filter[] = [];
  @Input() projectOnlyStatuses = false;
  @Output() statusesChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() {}

  allStatuses!: WorkReadyStatus[];

  ngOnInit() {
    this.loadStatuses();
  }

  addProduct(statusDef: WorkReadyStatus) {
    if (!this.statuses.find((sp) => sp.value === statusDef.id)) {
      this.statuses.push({ value: statusDef.id, displayName: statusDef.displayName, type: 'status' } as Filter);
    }
    this.statusesChange.emit(this.statuses);
  }

  removeProduct(statusDef: WorkReadyStatus) {
    const index = this.statuses.findIndex((sp) => sp.value === statusDef.id);
    if (index > -1) {
      this.statuses.splice(index, 1);
    }
    this.statusesChange.emit(this.statuses);
  }

  clear() {
    this.statuses = [];
    this.statusesChange.emit(this.statuses);
  }

  isSelected(statusDef: WorkReadyStatus): boolean {
    if (!this.statuses) return false;
    if (this.statuses.find((sp) => sp.value === statusDef.id)) return true;
    else return false;
  }

  loadStatuses() {
    if (this.projectOnlyStatuses === true) {
      this.allStatuses = [
        { id: 'BeingWorkedOn', displayName: 'BeingWorkedOn' },
        { id: 'ReadyToWorkOn', displayName: 'ReadyToWorkOn' },
        { id: 'Waiting', displayName: 'Waiting' },
        { id: 'Completed', displayName: 'Completed' },
        { id: 'OnHold', displayName: 'OnHold' },
        { id: 'Cancelled', displayName: 'Cancelled' },
      ];
    } else {
      this.allStatuses = [
        { id: 'BeingWorkedOn', displayName: 'BeingWorkedOn' },
        { id: 'ReadyToWorkOn', displayName: 'ReadyToWorkOn' },
        { id: 'Waiting', displayName: 'Waiting' },
        { id: 'Completed', displayName: 'Completed' },
        { id: 'OnHold', displayName: 'OnHold' },
        { id: 'Cancelled', displayName: 'Cancelled' },
        { id: 'Schedule', displayName: 'Schedule Actionable' },
        { id: 'ScheduleWaiting', displayName: 'Schedule Non-Actionable' },
        { id: 'ScheduleHoldReady', displayName: 'Schedule Hold Actionable' },
        { id: 'ScheduleHold', displayName: 'Schedule Hold Non-Actionable' },
      ];
    }
  }
}
